import service from './http';
import qs from 'qs';

const mock = false;
let config = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'X-Requested-With': 'XMLHttpRequest'
  }
};
let urlObject;
if (mock) {
  urlObject = {
    type: 'get',
    loginUrl: '/login.json',
    logOutUrl: '/logout.do',
    downloadUrl: '/download.xlsx',
    getLastTimeUrl: '/',
    recoverDefaultDaysUrl: '/',
    recoverDefaultWeeksUrl: '/',
    getDaysUrl: '/targetdays/show',
    uploadDaysUrl: '/uploadDays.json',
    //setDefaultDaysUrl: '/',
    saveDaysUrl: '/',
    uploadParameterUrl: '/uploadParameter.json',
    downloadParmeterHistoryUrl: '/download.xlsx',
    getParamterUrl: '/getParameter.json',
    getTimeUrl: '/getTime.json',
    getWeeksUrl: '/getWeeks.json',
    setTodefaultWeeksUrl: '/',
    calculateWeeksUrl: '/',
    getStoreListUrl: '/getStoreList.json',
    calculateSubmitUrl: '/',
    getAccountListUrl: '/accountlist.json',
    getRoleListUrl: '/roleList.json',
    getUserListUrl: '/userlist.json',
    editUserUrl: '',
    deleteUserUrl: '',
    addUserUrl: '',
    getSeasonStoreListUrl: '/storeList.json',
    getChartDataUrl: '/data.json',
    ResultProfitUrl: '/profit.json',
    ResultCostUrl: '/cost.json',
    ResultTargetDaysUrl: 'targetDays.json',
    ResultIsrUrl: '/isr.json',
    ResultServiceFrequencyUrl: '/serviceFrequency.json',
    ResultServiceTotalCostUrl: '/serviceTotalCost.json',
    ResultProfitFrequencyUrl: '/profitFrequency.json',
    ResultkpiUrl: '/kpi.json',
  }
} else {
  urlObject = {
    type: 'post',
    loginUrl: '/login.do',
    logOutUrl: '/logout.do',
    downloadUrl: '/postemplet/download',
    getLastTimeUrl: '/replenishment/pos',
    recoverDefaultDaysUrl: '/targetdays/reset', //恢复默认数据
    recoverDefaultWeeksUrl: '/fillinweekly/reset',
    getDaysUrl: '/targetdays/show',
    //getDaysUrl:'/ficoefficient/deletefica',
    uploadDaysUrl: '/replenishment/upload',
    //setDefaultDaysUrl: '/setDefaultDays',
    saveDaysUrl: '/targetdays/save',
    uploadParameterUrl: '/operation/params/upload',
    downloadParmeterHistoryUrl: '/operation/params/history',
    getParamterUrl: '/operation/params/pagination',
    getTimeUrl: '/operation/params/lastUpload.do',
    getWeeksUrl: '/fillinweekly/show',
    setTodefaultWeeksUrl: '/setTodefaultWeeks',
    calculateWeeksUrl: '/fillinweekly/save',
    getStoreListUrl: '/getStoreList',
    calculateStatusUrl: '/replenishment/getRunStatus',
    calculateSubmitUrl: '/replenishment/run',
    getAccountListUrl: '/user/accountlist',
    getRoleListUrl: '/user/rolelist',
    getUserListUrl: '/user/userlist',
    editUserUrl: '/user/edit',
    deleteUserUrl: '/user/delete',
    addUserUrl: '/user/save',
    getSeasonStoreListUrl: '/report/ids',
    getType1ChartDataUrl: '/report/reports',
    getType2ChartDataUrl: '/report/lastReport',
    getChartDataUrl: '',
    downloadReportUrl: '/report/download',
    ResultProfitUrl: '/moreReport/profit',
    ResultCostUrl: '/moreReport/cost',
    ResultTargetDaysUrl: '/moreReport/targetDay',
    ResultIsrUrl: '/moreReport/isr',
    ResultServiceFrequencyUrl: '/moreReport/serviceAngleFrequency',
    ResultServiceTotalCostUrl: '/moreReport/serviceAngleTotalCost',
    ResultProfitFrequencyUrl: '/moreReport/profitAngleFrequency',
    ResultkpiUrl: '/moreReport/kpi',
    CheckHealthUrl: '/session/available',
  }
}
export const Login = data => {
  return service({
    url: urlObject.loginUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  //return service.get(urlObject.loginUrl,qs.stringify(data));
  //return service.post('/login',qs.stringify(data));
};

export const logOut = _ => {
  return service({
    url: urlObject.logOutUrl,
    method: urlObject.type,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
};


export const recoverDefaultDays = data => {
  return service({
    url: urlObject.recoverDefaultDaysUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const recoverDefaultWeeks = data => {
  return service({
    url: urlObject.recoverDefaultWeeksUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getDays = data => {
  return service({
    url: urlObject.getDaysUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const Download = _ => {
  return service({
    url: urlObject.downloadUrl,
    // method: urlObject.type,
    method: 'get',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getLastTime = data => {
  return service({
    url: urlObject.getLastTimeUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}
export const uploadFile = data => {
  return service({
    url: urlObject.uploadDaysUrl,
    method: urlObject.type,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Requested-With': 'XMLHttpRequest'
    },
    data: data
  })
}

/*export const setDefaultDays = data => {
  return service({
    url: urlObject.setDefaultDaysUrl,
    method: urlObject.type,
    data: data
  })
}*/

export const saveDays = data => {
  return service({
    url: urlObject.saveDaysUrl,
    method: urlObject.type,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    data: data
  })
}

export const uploadParameterFile = data => {
  return service({
    url: urlObject.uploadParameterUrl,
    method: urlObject.type,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Requested-With': 'XMLHttpRequest'
    },
    data: data
  })
}

export const downloadParmeterHistory = data => {
  return service({
    url: urlObject.downloadParmeterHistoryUrl,
    method: 'get',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getParamterList = _ => {
  return service({
    url: urlObject.getParamterUrl,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getTime = _ => {
  return service({
    url: urlObject.getTimeUrl,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getWeeksList = data => {
  return service({
    url: urlObject.getWeeksUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const setToDefaultWeeks = data => {
  return service({
    url: urlObject.setTodefaultWeeksUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const weekCalculate = data => {
  return service({
    url: urlObject.calculateWeeksUrl,
    method: urlObject.type,
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}


export const getStoreList = _ => {
  return service({
    url: urlObject.getStoreListUrl,
    method: urlObject.type,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const calculateStatus = data => {
  return service.get(urlObject.calculateStatusUrl, {
    params: data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const calculateSubmit = data => {
  return service({
    url: urlObject.calculateSubmitUrl,
    method: urlObject.type,
    data: data,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getUserList = data => {
  return service.get(urlObject.getUserListUrl, {
    params: data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getAccountList = _ => {
  return service({
    url: urlObject.getAccountListUrl,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getRoleList = _ => {
  return service({
    url: urlObject.getRoleListUrl,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const editUser = data => {
  return service({
    url: urlObject.editUserUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const deleteUser = data => {
  return service({
    url: urlObject.deleteUserUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const addUser = data => {
  return service({
    url: urlObject.addUserUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const editOneUser = data => {
  return service({
    url: urlObject.editUserUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getChartData = data => {
  return service({
    url: urlObject.getChartDataUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getSeasonStoreList = data => {
  return service({
    url: urlObject.getSeasonStoreListUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getType1ChartData = data => {
  return service({
    url: urlObject.getType1ChartDataUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const getType2ChartData = data => {
  return service({
    url: urlObject.getType2ChartDataUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const downloadReport = data => {
  return service.get(urlObject.downloadReportUrl, {
    params: data,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultProfit = data => {
  return service({
    url: urlObject.ResultProfitUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultCost = data => {
  return service({
    url: urlObject.ResultCostUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultTargetDays = data => {
  return service({
    url: urlObject.ResultTargetDaysUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultIsr = data => {
  return service({
    url: urlObject.ResultIsrUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultServiceFrequency = data => {
  return service({
    url: urlObject.ResultServiceFrequencyUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultServiceTotalCost = data => {
  return service({
    url: urlObject.ResultServiceTotalCostUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const ResultProfitFrequency = data => {
  return service({
    url: urlObject.ResultProfitFrequencyUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const Resultkpi = data => {
  return service({
    url: urlObject.ResultkpiUrl,
    method: urlObject.type,
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export const CheckHealth = _ => {
	  return service({
	    url: urlObject.CheckHealthUrl,
	    method: 'get',
	    headers: {
	      'Content-Type': 'application/x-www-form-urlencoded',
	      'X-Requested-With': 'XMLHttpRequest'
	    }
	  })
	}





// WEBPACK FOOTER //
// ./src/util/api.js